export default {
    successAddedToCart: 'Додано до кошика',
    smsTitle: 'Шаблони смс',
    mapTitle: 'Мапа',
    blocksTitle: 'Блокування рибалки'
}
